import type { FieldValues, Path, UseFormSetError } from 'react-hook-form'

import { AxiosError } from 'axios'

interface ApiFieldErrorResponse {
  errors?: Record<string, string[]>
}

export type ApiFieldErrorMap<TFormValues extends FieldValues> = Record<
  string,
  Path<TFormValues>
>

export const applyApiFieldErrors = <TFormValues extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<TFormValues>,
  fieldMap: ApiFieldErrorMap<TFormValues>,
): boolean => {
  if (!(error instanceof AxiosError)) {
    return false
  }

  const errorData = error.response?.data as ApiFieldErrorResponse | undefined
  const fieldErrors = errorData?.errors

  if (!fieldErrors) {
    return false
  }

  let hasAppliedError = false

  Object.entries(fieldErrors).forEach(([apiField, messages]) => {
    const fieldName = fieldMap[apiField]
    const message = messages[0]

    if (!fieldName || !message) {
      return
    }

    setError(fieldName, {
      type: 'server',
      message,
    })
    hasAppliedError = true
  })

  return hasAppliedError
}
